import { GridApi } from 'ag-grid-community';

/**
 * Sets the initial sort state for the obsolete column with the specified exercice.
 * We need to do this here because we don't want the sort to apply to other exercices.
 *
 * @param {GridApi} gridApi - The Grid API instance used to manipulate grid states.
 * @param {number} exercice - The specific exercise year to be used.
 */
export const setInitialSort = (gridApi: GridApi, exercice: number) =>
    gridApi.applyColumnState({
        state: [
            {
                colId: `pivot_budgetLine.year_${exercice}_projection_obsolete`,
                sort: 'desc',
            },
        ],
        defaultState: { sort: null },
    });

/**
 * Handles the sort change event and ensures that the obsolete column is sorted if it is not already.
 * We did this to make sure that the obsolete line is always at the bottom even if the user sort another column.
 *
 * @param {GridApi} gridApi - The Grid API instance used to manipulate grid states.
 * @param {number} exercice - The specific exercise year to be used.
 */
export const handleSortChanged = (gridApi: GridApi, exercice: number) => {
    const sortColumns = gridApi
        .getColumnState()
        .filter((c) => c.sort != null)
        .map((c) => ({
            colId: c.colId,
            sort: c.sort,
            sortIndex: c.sortIndex ?? 0,
        }));

    if (
        sortColumns.some(
            (c) =>
                c.colId ===
                `pivot_budgetLine.year_${exercice}_projection_obsolete`,
        )
    ) {
        return;
    }

    const maxSortIndex = Math.max(
        ...sortColumns.map(({ sortIndex }) => sortIndex),
    );

    gridApi.applyColumnState({
        state: [
            ...sortColumns,
            {
                colId: `pivot_budgetLine.year_${exercice}_projection_obsolete`,
                sort: 'desc',
                sortIndex: maxSortIndex + 1,
            },
        ],
        defaultState: { sort: null },
    });
};
